module.exports = __webpack_public_path__ + "static/media/Wolf Costume.bb6d7945.jpg";